export default __webpack_public_path__ + "static/media/line-plot-categories-blue.2f79a12f.svg";